import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { baseURL, tipddytoken } from "../../services/apirest";
import { useAuth } from "../../contexts/AuthContext";
import dic from "../../utils/languages.json";
import { getCurrentUser } from "../../services/moodle/userauth";
const SERVICE_NAME = "moodle_mobile_app"; // shortname del servicio web

const Callback = () => {
  const navigate = useNavigate();
   const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Cargando...");

  useEffect(() => {
    const userkey = searchParams.get("userkey");
    if (!userkey) return setStatus("Falta userkey");

    const getToken = async () => {
      try {
        const url = `https://admin.aprendersteam.com/webservice/rest/server.php?wstoken=YOUR_SERVICE_TOKEN&wsfunction=auth_userkey_tipddy_request_login_token&moodlewsrestformat=json&userkey=${userkey}`;

        const res = await fetch(url);
        const data = await res.json();

        if (data?.token) {
          localStorage.setItem("moodle_token", data.token);
          setStatus("Login exitoso ✅");
          // Aquí podrías redirigir al dashboard de tu SPA
          navigate("/listcourses");
        } else {
          setStatus("Error obteniendo token");
          console.error(data);
          navigate("/");
        }
      } catch (err) {
        console.error(err);
        setStatus("Error de red");
        navigate("/");
      }
    };

    getToken();
  }, [searchParams]);

  return <p>Iniciando sesión...</p>;
};

export default Callback;
